<template>
  <div>
       <Layout/>
       <div class="page">
        <h1>Configurações </h1>
       </div>      
  </div>
</template>

<script>
export default {
  name: 'App', 
  data () {
    return {
      session: false,
      dark: false
    };
  },
  created () {
  },
  methods:{     
  }
};
</script>

<style>
.page{
  margin:30px;
}
</style>